var WorkErrorAcceptanceModal = (function (base) {
  __extends(WorkErrorAcceptanceModal, base);

  function WorkErrorAcceptanceModal(apiClient) {
    var self = base.call(this, apiClient) || this;
    return self;
  };

  WorkErrorAcceptanceModal.prototype.activate = function (htmlContent, acceptanceHead, description, workIds) {
    const self = this;
    const $modal = ModalHelper.create().show().busy();
    self.$modal = $modal;

    htmlContent = htmlContent
        .replace('\${acceptanceHead}', acceptanceHead)
        .replace('\${workIds}', workIds)
        .replace('\${description}', description);
    $($modal).find('.modal-dialog').addClass('modal-login');
    $modal.content(htmlContent).busy(false);

    $modal
      .on('click', '[js=close],.close', () => {
        self.close({ cancel: true });
      })
      .on('keydown',
        e => {
          if (e.keyCode === 27) {
            self.close({ cancel: true });
            e.stopPropagation();
          }
        });
  };

  return WorkErrorAcceptanceModal;
}(BaseModal));
